import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as orderActions from "../../../../../actions/intergammaOrderActions";

class WarningCustomerModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    getCustomer = () => {
        if (
            this.props.params === undefined ||
            this.props.params.customer === undefined ||
            this.props.params.customer === null
        ) {
            return null;
        }

        return this.props.params.customer;
    };

    handleButtonClick = () => {
        if (this.props.params.barcode !== null) {
            if (this.props.params.barcode.startsWith("%O")) {
                this.props.dispatchSendOrderByBarcodeAction(
                    this.props.tabId,
                    this.props.params.formula,
                    this.props.params.barcode,
                    this.props.params.receiver
                );
            } else {
                this.props.dispatchSendOrderByHistoryBarcodeAction(
                    this.props.tabId,
                    this.props.params.formula,
                    this.props.params.barcode,
                    this.props.params.receiver
                );
            }
        } else {
            this.props.dispatchSendOrderAction(
                this.props.tabId,
                this.props.params.product,
                this.props.params.fandeck,
                this.props.params.color,
                this.props.params.formula,
                this.props.params.base,
                this.props.params.packageItem,
                this.props.params.customer,
                this.props.params.packageCount,
                this.props.params.databaseName,
                this.props.params.receiver,
                this.props.params.customNote
            );
        }

        this.props.dispatchCloseModalAction();
    };

    getTitle = () => {
        let customer = this.getCustomer();

        if (customer === null) {
            return <Translate value="customRedlike.noCustomerSelected" />;
        }

        return <Translate value="customRedlike.confirmSelectedUser" customerName={customer.name} />;
    };

    render() {
        return (
            <div id="modal" className="default-modal ig-restart-modal ig-small-modal">
                <div className="modal-content">
                    <div className="col-xs-12 ">{this.getTitle()}</div>
                    <div className="modal-footer">
                        <div className="col-xs-6 text-right">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleCloseModalClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.cancel" />
                            </button>
                        </div>
                        <div className="col-xs-6 text-left ">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleButtonClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.confirm" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_WARNING_CUSTOMER_MODAL));
        },
        dispatchSendOrderAction: (
            tabId,
            product,
            fandeck,
            color,
            formula,
            base,
            packageItem,
            customer,
            packageCount,
            databaseName,
            receiver,
            customNote
        ) => {
            dispatch(
                orderActions.sendOrder(
                    tabId,
                    product,
                    fandeck,
                    color,
                    formula,
                    base,
                    packageItem,
                    customer,
                    packageCount,
                    databaseName,
                    receiver,
                    customNote
                )
            );
        },
        dispatchSendOrderByBarcodeAction: (tabId, formula, barcode, receiver) => {
            dispatch(orderActions.sendOrderByBarcode(tabId, formula, barcode, receiver));
        },
        dispatchSendOrderByHistoryBarcodeAction: (tabId, formula, barcode, receiver) => {
            dispatch(orderActions.sendOrderByHistoryBarcode(tabId, formula, barcode, receiver));
        }
    };
};

export default WarningCustomerModal = connect(mapStoreToProps, mapDispatchToProps)(WarningCustomerModal);
